import { useMemo } from "react";

import { LogoSVGEmbed } from "@transfr-inc/dashboard-components";
import { Product } from "@transfr-inc/dashboard-components/constants";
import {
  getProduct,
  getProductDescription,
  getProductDisplayName,
} from "@transfr-inc/dashboard-components/utils";

import { DashboardHero } from "./dashboard.hero";

import "./dashboard.banner.scss";

export function DashboardBanner({ product, description, image }) {
  const productNameElement = useMemo(() => {
    let spanContent;

    switch (product) {
      case Product.TS:
        spanContent = getProductDisplayName(Product.TS);
        break;
      case Product.TRK:
      case Product.CE:
        const { alternateDisplayName, subProduct } = getProduct(product);

        spanContent = (
          <>
            <span>{alternateDisplayName}</span>
            <span className="badge">{subProduct}</span>
          </>
        );
        break;
    }

    return spanContent && <span>{spanContent}</span>;
  }, [product]);

  return (
    <div className="dashboard-banner">
      <div className="text">
        <h2>
          <LogoSVGEmbed />
          {productNameElement}
        </h2>
        <p>{description ?? getProductDescription(product)}</p>
      </div>
      <div className="image-container">
        <div className="shapes">
          <img className="cube top" src="/images/shapes/cube.png" alt="cube" />
          <img
            className="cube bottom"
            src="/images/shapes/cube.png"
            alt="cube"
          />
          <img
            className="spiral"
            src="/images/shapes/spiral.png"
            alt="spiral"
          />
        </div>

        <DashboardHero product={product} />
      </div>
    </div>
  );
}
